import { useState, useCallback, useEffect } from 'react';
import * as AV from '../AVCore/AVCore';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { setFeeds, setProcessedHomeFeeds, setRemainingPostsToFetch } from '../Redux/Actions/feedsAction';

// Assume AV is globally available or imported
// import AV from 'path-to-AV';

export default function useFeedsProfile ( props : any )
{
    const [ feeds, setFeedsState ] = useState<any[]>( [] );
    const [ groupedPostIds, setGroupedPostIds ] = useState<any>( {} );
    const [ hasMore, setHasMore ] = useState( true );
    const [ loading, setLoading ] = useState( false );
    const dispatch = useDispatch();
    const previousFeeds = useSelector( ( state : any ) => state.feeds.feeds[ 0 ] ) ?? [];
    const previousProcessedFeeds = useSelector( ( state : any ) => state.feeds.processedHomeFeeds ) ?? [];
    const remainingPostsToFetch = useSelector( ( state : any ) => state.feeds.remainingPostsToFetch ) ?? [];

    const { Entity } = props;

    const list_to_tree = ( list ) =>
    {
        var map = {}, node : any, roots : any = [], i;

        for ( i = 0; i < list?.length; i += 1 )
        {
            map[ list[ i ]?.id ] = i; // initialize the map
            if ( list[ i ]?.children?.length === 0 || !list[ i ]?.children )
                list[ i ][ "children" ] = []; // initialize the children
            if ( list[ i ]?.galleryPost?.length === 0 || !list[ i ]?.galleryPost )
                list[ i ][ "galleryPost" ] = [];
        }

        for ( i = 0; i < list?.length; i += 1 )
        {
            node = list[ i ];
            if ( node.parentPost )
            {
                if ( list[ map[ node.parentPost ] ]?.gallery?.items?.filter( ( x ) => x === node.id )?.length > 0 && !node.gallery )
                {
                    let excitingpost = list[ map[ node.parentPost ] ]?.galleryPost?.filter( x => x?.id === node?.id );
                    if ( excitingpost?.length === 0 || !excitingpost )
                        list[ map[ node.parentPost ] ]?.galleryPost.push( node );
                } else
                {
                    let excitingcomment = list[ map[ node.parentPost ] ]?.children?.filter( x => x?.id === node?.id );
                    if ( excitingcomment?.length === 0 || !excitingcomment )
                        list[ map[ node.parentPost ] ]?.children.push( node );
                }
            } else
            {
                roots.push( node );
            }
        }
        return roots; // Return the tree structure
    };

    // Group posts helper
    const groupPosts = async ( allPosts : { id : string; date : string; owner : any; ownerType : string | null }[] ) =>
    {
        let groupedPostIds : { [ key : string ] : { owner : any; postIds : { id : string; date : string }[]; ownerType : string } } = {};
        let previousOwnerId = "";
        allPosts.sort( ( a, b ) => new Date( b.date ).getTime() - new Date( a.date ).getTime() );
        allPosts.forEach( post =>
        {
            const { owner, ownerType } = post;
            const ownerId = owner.id;
            if ( ownerId !== previousOwnerId )
            {
                if ( ownerId && !groupedPostIds[ ownerId ] )
                {
                    groupedPostIds[ ownerId ] = { owner: owner, postIds: [], ownerType: ownerType || '' };
                }
                if ( ownerId && groupedPostIds[ ownerId ] )
                {
                    groupedPostIds[ ownerId ].postIds.push( { id: post.id, date: post.date } );
                    previousOwnerId = ownerId;
                }
            } else
            {
                if ( ownerId && groupedPostIds[ ownerId ] )
                {
                    groupedPostIds[ ownerId ].postIds.push( { id: post.id, date: post.date } );
                }
            }
        } );
        return groupedPostIds;
    };

    const getPostsToFetch = ( postGroup : any ) =>
    {
        const postsToFetch : AV.IPostListParam[] = [];
        for ( const ownerId in postGroup )
        {
            const { owner, postIds } = postGroup[ ownerId ];
            postsToFetch.push( { feed: owner, ids: postIds.map( ( post ) => post.id ) } );
        }
        return postsToFetch;
    };

    useEffect( () =>
    {
        const fetchInitialFeeds = async () =>
        {
            setLoading( true );
            try
            {
                // Check if we already have processed feeds for this entity
                const alreadyProcessed = previousProcessedFeeds?.filter( x => x?.id === Entity?.id );
                if ( alreadyProcessed && alreadyProcessed.length > 0 )
                {
                    // Use previousFeeds for posts with owner.id === Entity.id
                    let filteredPosts = ( previousFeeds || [] ).filter( x => x?.owner?.id === Entity?.id );
                    filteredPosts = filteredPosts.sort( ( a : any, b : any ) =>
                    {
                        const dateA = new Date( a?.createDate ).getTime();
                        const dateB = new Date( b?.createDate ).getTime();
                        return dateB - dateA; // Sort posts by creation date in descending order
                    } );
                    setFeedsState( _.uniqBy( filteredPosts, 'id' ) );

                    // Check if there are still posts to fetch for this entity
                    const entityRemainingPosts = remainingPostsToFetch.filter(
                        ( group ) => group.feed?.pk === Entity?.id && group.ids.length > 0
                    );
                    setHasMore( entityRemainingPosts.length > 0 && filteredPosts.length > 0);
                    setLoading( false );
                    CheckNewPostAvailble(filteredPosts[0])
                    return;
                }
                const feedParams = {
                    feed: {
                        id: Entity?.id,
                        pk: Entity?.id,
                        type: 'Feed',
                    },
                    startDate: new Date( 0 ),
                    forward: true,
                    checkArchive: false,
                };
                const feeds = await AV.Feed.getAllFeeds( [ feedParams ] );
                // Store processed getFeed result in Redux (merge with previous, unique by id)
                const mergedProcessedFeeds = _.uniqBy( [ ...( previousProcessedFeeds || [] ), ...( feeds || [] ) ], 'id' );
                dispatch( setProcessedHomeFeeds( mergedProcessedFeeds ) );
                // Collect all post IDs from all feeds
                let allPosts : { id : string; date : string; owner : any; ownerType : string | null }[] = [];
                feeds.forEach( feed =>
                {
                    const feedFK = AV.AVEntity.getFk( feed );
                    const currentEntityPostIds = _.uniqBy( [
                        ...( feed?.followIds || [] ),
                        ...( feed?.privateIds || [] ),
                        ...( feed?.publicIds || [] ),
                        ...( feed?.orgIds || [] )
                    ], 'id' );
                    const ownerType = feed.type;
                    currentEntityPostIds.forEach( postId =>
                    {
                        if ( postId.id && postId.date )
                        {
                            allPosts.push( {
                                id: postId.id,
                                date: new Date( postId.date ?? new Date() ).toISOString(),
                                owner: feedFK,
                                ownerType: ownerType || null
                            } );
                            if ( Array.isArray( postId.gallery ) && postId.gallery.length > 0 )
                            {
                                postId.gallery.forEach( galleryId =>
                                {
                                    allPosts.push( {
                                        id: galleryId,
                                        date: new Date( postId.date ?? new Date() ).toISOString(),
                                        owner: feedFK,
                                        ownerType: ownerType || null
                                    } );
                                } );
                            }
                        } else
                        {
                            console.warn( 'Post ID or date is missing:', postId );
                        }
                    } );
                } );
                const grouped = await groupPosts( allPosts );
                // Chunk ids for each group
                const chunkedPostsToFetch : any[] = [];
                const remainingChunks : any[] = [];
                for ( const ownerId in grouped )
                {
                    const { owner, postIds } = grouped[ ownerId ];
                    const ids = postIds.map( post => post.id );
                    if ( ids.length > 20 )
                    {
                        chunkedPostsToFetch.push( { feed: owner, ids: ids.slice( 0, 20 ) } );
                        remainingChunks.push( { feed: owner, ids: ids.slice( 20 ) } );
                    } else
                    {
                        chunkedPostsToFetch.push( { feed: owner, ids } );
                    }
                }
                // Remove old chunks for this entity, keep others
                const updatedRemainingPosts = [
                    ...remainingPostsToFetch.filter(group => group.feed?.pk !== Entity?.id),
                    ...remainingChunks.filter(x => x.ids.length > 0)
                ];
                dispatch(setRemainingPostsToFetch(updatedRemainingPosts));
                let postList = await AV.Feed.getAllPosts( chunkedPostsToFetch );
                postList = list_to_tree( postList );
                postList = postList.sort( ( a : any, b : any ) =>
                {
                    const dateA = new Date( a?.createDate ).getTime();
                    const dateB = new Date( b?.createDate ).getTime();
                    return dateB - dateA; // Sort posts by creation date in descending order
                } );
                setFeedsState( postList );
                // Merge previous feeds and new posts, ensure uniqueness by 'id'
                let mergedFeeds = _.uniqBy( [ ...( previousFeeds || [] ), ...( postList || [] ) ], 'id' );
                mergedFeeds = mergedFeeds.sort((a:any,b:any ) =>
                {
                    const dateA = new Date( a?.createDate ).getTime();
                    const dateB = new Date( b?.createDate ).getTime();
                    return dateB - dateA; // Sort posts by creation date in descending order
                } );
                mergedFeeds = list_to_tree( mergedFeeds );
                dispatch( setFeeds( mergedFeeds ) );
                setHasMore( remainingChunks.some( x => x.ids.length > 0 ) );
            } catch ( error )
            {
                // Handle error (optional)
            } finally
            {
                setLoading( false );
            }
        };
        if ( Entity?.id )
        {
            fetchInitialFeeds();
        }
    }, [ Entity?.id ] );

    const CheckNewPostAvailble = async ( LatestPost ) =>
    {
        const feedParams = {
            feed: {
                id: Entity?.id,
                pk: Entity?.id,
                type: 'Feed',
            },
            startDate: LatestPost.lastUpdated,
            forward: true,
            checkArchive: false,
        };
        const feeds: any = await AV.Feed.getAllFeeds( [ feedParams ] );
        if ( feeds[ 0 ]?.privateIds?.length > 0 || feeds[ 0 ]?.publicIds?.length > 0 || feeds[ 0 ]?.followIds?.length > 0 )
        { 
            setLoading( true );
        // Collect all post IDs from all feeds
        let allPosts : { id : string; date : string; owner : any; ownerType : string | null }[] = [];
        feeds.forEach( feed =>
        {
            const feedFK = AV.AVEntity.getFk( feed );
            const currentEntityPostIds = _.uniqBy( [
                ...( feed?.followIds || [] ),
                ...( feed?.privateIds || [] ),
                ...( feed?.publicIds || [] )
            ], 'id' );
            const ownerType = feed.type;
            currentEntityPostIds.forEach( postId =>
            {
                if ( postId.id && postId.date )
                {
                    allPosts.push( {
                        id: postId.id,
                        date: new Date( postId.date ?? new Date() ).toISOString(),
                        owner: feedFK,
                        ownerType: ownerType || null
                    } );
                    if ( Array.isArray( postId.gallery ) && postId.gallery.length > 0 )
                    {
                        postId.gallery.forEach( galleryId =>
                        {
                            allPosts.push( {
                                id: galleryId,
                                date: new Date( postId.date ?? new Date() ).toISOString(),
                                owner: feedFK,
                                ownerType: ownerType || null
                            } );
                        } );
                    }
                } else
                {
                    console.warn( 'Post ID or date is missing:', postId );
                }
            } );
        } );
        const grouped = await groupPosts( allPosts );
        // Chunk ids for each group
        const chunkedPostsToFetch : any[] = [];
        const remainingChunks : any[] = [];
        for ( const ownerId in grouped )
        {
            const { owner, postIds } = grouped[ ownerId ];
            const ids = postIds.map( post => post.id );
            if ( ids.length > 20 )
            {
                chunkedPostsToFetch.push( { feed: owner, ids: ids.slice( 0, 20 ) } );
                remainingChunks.push( { feed: owner, ids: ids.slice( 20 ) } );
            } else
            {
                chunkedPostsToFetch.push( { feed: owner, ids } );
            }
        }
        // Remove old chunks for this entity, keep others
        const updatedRemainingPosts = [
            ...remainingPostsToFetch.filter( group => group.feed?.pk !== Entity?.id ),
            ...remainingChunks.filter( x => x.ids.length > 0 )
        ];
        dispatch( setRemainingPostsToFetch( updatedRemainingPosts ) );
        let postList = await AV.Feed.getAllPosts( chunkedPostsToFetch );
        let alreadyHaveFeed = ( previousFeeds || [] ).filter( x => x?.owner?.id === Entity?.id )
        postList = _.uniqBy( [ ...( alreadyHaveFeed || [] ), ...( postList || [] ) ], 'id' );
        postList = list_to_tree( postList );
        postList = postList.sort( ( a : any, b : any ) =>
        {
            const dateA = new Date( a?.createDate ).getTime();
            const dateB = new Date( b?.createDate ).getTime();
            return dateB - dateA; // Sort posts by creation date in descending order
        } );
        setFeedsState( postList );
        // Merge previous feeds and new posts, ensure uniqueness by 'id'
        let mergedFeeds = _.uniqBy( [ ...( previousFeeds || [] ), ...( postList || [] ) ], 'id' );
        mergedFeeds = mergedFeeds.sort( ( a : any, b : any ) =>
        {
            const dateA = new Date( a?.createDate ).getTime();
            const dateB = new Date( b?.createDate ).getTime();
            return dateB - dateA; // Sort posts by creation date in descending order
        } );
        mergedFeeds = list_to_tree( mergedFeeds );
        dispatch( setFeeds( mergedFeeds ) );
            const OldFeed : any = previousProcessedFeeds?.filter( x => x?.id == feeds[ 0 ]?.id );
            const UpdatedFeed : any = feeds;
            UpdatedFeed[ 0 ].privateIds = _.uniqBy( [ ...( UpdatedFeed[ 0 ]?.privateIds || [] ), ...( OldFeed[ 0 ]?.privateIds || [] ) ], 'id' );
            UpdatedFeed[ 0 ].publicIds = _.uniqBy( [ ...( UpdatedFeed[ 0 ]?.publicIds || [] ), ...( OldFeed[ 0 ]?.publicIds || [] ) ], 'id' );
            UpdatedFeed[ 0 ].followIds = _.uniqBy( [ ...( UpdatedFeed[ 0 ]?.followIds || [] ), ...( OldFeed[ 0 ]?.followIds || [] ) ], 'id' );
            const mergedProcessedFeeds = _.uniqBy( [ ...( previousProcessedFeeds || [] ), ...( UpdatedFeed || [] ) ], 'id' );
            dispatch( setProcessedHomeFeeds( mergedProcessedFeeds ) );
            setHasMore( remainingChunks.some( x => x.ids.length > 0 ) );
            setLoading( false );
    }
    }

    // Fetch more posts on scroll
    const fetchMore = useCallback( async () =>
    {
        const entityId = Entity?.id;
        const entityRemainingPosts = remainingPostsToFetch.filter(
            ( group ) => group.feed?.pk === entityId
        );

        if ( !entityRemainingPosts.length )
        {
            setHasMore( false );
            return;
        }
        // For each group, fetch next 20 ids
        const nextChunks : any = [];
        const toFetch : any = [];
        entityRemainingPosts.forEach( group =>
        {
            if ( group.ids.length > 20 )
            {
                toFetch.push( { feed: group.feed, ids: group.ids.slice( 0, 20 ) } );
                nextChunks.push( { feed: group.feed, ids: group.ids.slice( 20 ) } );
            } else
            {
                toFetch.push( { feed: group.feed, ids: group.ids } );
            }
        } );

        // Update only the current entity's chunk in Redux
        const updatedRemainingPosts = [
            ...remainingPostsToFetch.filter( group => group.feed?.pk !== entityId ),
            ...nextChunks.filter( x => x.ids.length > 0 )
        ];
        dispatch( setRemainingPostsToFetch( updatedRemainingPosts ) );

        if ( toFetch.length )
        {
            let morePosts = await AV.Feed.getAllPosts( toFetch );
            setFeedsState( prev =>
            {
                let merged = _.uniqBy( [ ...( prev || [] ), ...( morePosts || [] ) ], 'id' );
                // Also update Redux
                merged = list_to_tree( merged );
                merged = merged.sort( ( a, b ) =>
                {
                    const dateA = new Date( a?.createDate ).getTime();
                    const dateB = new Date( b?.createDate ).getTime();
                    return dateB - dateA; // Sort posts by creation date in descending order
                } );
                dispatch( setFeeds( _.uniqBy( [ ...( previousFeeds || [] ), ...merged ], 'id' ) ) );
                return merged;
            } );
        }
        if ( !nextChunks.length ) setHasMore( false );
    }, [ remainingPostsToFetch, previousFeeds, dispatch ] );

    return { feeds, setFeeds: setFeedsState, groupedPostIds, fetchMore, hasMore, loading };
}
